import { useLocation, useNavigate } from "react-router-dom";

/**
 * Back handler returning to the previous page, or undefined when the page was
 * opened directly. Pass `canGoBack` when the page decides it itself.
 */
export function useHistoryBack(canGoBack?: boolean): (() => void) | undefined {
  const navigate = useNavigate();
  const location = useLocation();
  const hasPreviousPage = canGoBack ?? location.key !== "default";
  return hasPreviousPage ? () => navigate(-1) : undefined;
}
